import { Flex, Heading } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Overview } from './components/Overview.jsx';
import { DetailedCharts } from './components/DetailedChart.jsx';
import { AiSummary } from './components/AiSummary.jsx';
import { BroadcastsSummary } from './components/BroadcastsSummary.jsx';
import SectionCard from '../../../shared/SectionCard/SectionCard.jsx';
import styles from './components/DetailedChart.module.css';

import { useCampaignFilter } from '../hooks/useCampaignFilter';

const CampaignReports = () => {
  const { campaignId } = useCampaignFilter();
  const { t } = useTranslation('reports');
  const hasAiAssistant = useSelector(
    state => state.currentBoard.hasAiAssistant,
  );
  const history = useHistory();

  return (
    <Flex direction="column" gap="3">
      <SectionCard
        className={styles.overflowVisible}
        contentClassName={styles.overflowVisible}
        headerContent={
          <Flex align="center" gap="2">
            <i
              className="fa-regular fa-clipboard-list"
              style={{ color: 'var(--indigo-9)' }}
            />
            <Heading size="4" m="0">
              {t('summary.groups.highlights')}
            </Heading>
          </Flex>
        }
      >
        <Overview campaignId={campaignId} />
        <DetailedCharts campaignId={campaignId} />
      </SectionCard>
      {hasAiAssistant && <AiSummary />}
      <BroadcastsSummary
        onViewAll={() => {
          history.push('?tab=broadcasts');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      />
    </Flex>
  );
};

export default CampaignReports;
